































































import DamageLocatorCombined from "@/components/damagelocator/DamageLocatorCombined.vue";
import ReportPositionHitZones from "@/components/partner/ReportPositionHitZones.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReport } from "@/models/report.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import MImageMarker from "../utility/mmmint/MImageMarker.vue";
import PartnerReportUpdateReportDialog, { ReportUpdateTabEnum } from "./PartnerReportUpdateReportDialog.vue";

@Component({
  components: { PartnerReportUpdateReportDialog, DamageLocatorCombined, MImageMarker, ReportPositionHitZones }
})
export default class ReportDamageLocationTimeLineElement extends mixins(PermissionMixin) {
  readonly ReportUpdateTabEnum = ReportUpdateTabEnum;

  @Prop({ default: "primary" })
  color!: string;

  @Prop({ default: "#6fb38a" })
  clickedColor!: string;

  @Prop()
  report!: IReport;

  renderComponent = true;

  get getDamageLocatorWidth() {
    return "250px";
  }

  get damageLocation() {
    this.forceRerender();
    return this.report?.damage;
  }

  get hasDamageLocation(): boolean {
    return this.damageLocation?.length > 0 || this.report.position != undefined;
  }

  forceRerender() {
    // remove the my-component component from the DOM
    this.renderComponent = false;

    this.$nextTick(() => {
      // add my-component component in DOM
      this.renderComponent = true;
    });
  }
}
